import * as Yup from 'yup';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik, FormikProvider } from 'formik';
import saveIcon from '@iconify/icons-eva/save-outline';
// material
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { editItem } from '../../fetch';
import { useTranslation } from '../../common/LocalizationProvider';
import CountrySelect from '../CountrySelect';
import { aerosActions } from '../../store';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------
const initialValues = {
  oaci: '',
  nom: '',
  alti: '',
  lat: '',
  lon: '',
  country: 'FR'
};

// ----------------------------------------------------------------------

AerosForm.propTypes = {
  aeroId: PropTypes.number,
  aero: PropTypes.object
};

export default function AerosForm({ aeroId, aero }) {
  const t = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const session = useSelector(selectSession);

  const RegisterSchema = Yup.object().shape({
    alti: Yup.number(t('yupValid_Invalid')),
    country: Yup.string().required(t('yupValid_Required'))
  });

  const formik = useFormik({
    initialValues: aero !== undefined ? aero : initialValues,
    validationSchema: RegisterSchema,
    onSubmit: async (values) => {
      const response = await editItem('aeros', aeroId, values);
      if (response.ok) {
        if (session.administrator) {
          enqueueSnackbar(
            aero !== undefined ? t('Aero_Add_Snackbar_Change') : t('Aero_Add_Snackbar_Add'),
            {
              variant: 'success'
            }
          );
        } else {
          enqueueSnackbar(t('Aero_Add_Snackbar_Add_Mail'), { variant: 'success' });
        }

        dispatch(aerosActions.update([await response.json()]));
        navigate(-1);
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
        setSubmitting(false);
      }
    }
  });

  const { handleSubmit, isSubmitting, getFieldProps, setSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Stack spacing={3}>
        <TextField fullWidth autoComplete="oaci" label="oaci" {...getFieldProps('oaci')} />

        <TextField
          fullWidth
          autoComplete="nom"
          label={t('fields_Name')}
          {...getFieldProps('nom')}
        />

        {session.administrator && (
          <TextField
            fullWidth
            autoComplete="alti"
            type="number"
            {...getFieldProps('alti')}
            label={t('fields_Altitude')}
          />
        )}

        <TextField
          fullWidth
          autoComplete="lat"
          {...getFieldProps('lat')}
          label={t('fields_Latitude')}
        />

        <TextField
          fullWidth
          autoComplete="lon"
          {...getFieldProps('lon')}
          label={t('fields_Longitude')}
        />

        <CountrySelect formik={formik} {...getFieldProps('country')} />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          startIcon={<Icon icon={saveIcon} />}
          onClick={handleSubmit}
        >
          {t('btn_Save')}
        </LoadingButton>
      </Stack>
    </FormikProvider>
  );
}
